






import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
            params: null as any
        }
    },
    computed: {
        value(): number | string {
            return this.params.render(this.params.colDef.field, this.params.data);
        }
    }
})
